import SEO from "@/components/SEO";
import { Eyebrow } from "@/components/Motion";

export default function Privacy() {
  return (
    <div className="pt-16" data-testid="privacy-page">
      <SEO
        title="Privacy Policy"
        description="Privacy Policy for Incolour Films Inc., including website inquiries, analytics, cookies, service providers and privacy requests."
        path="/privacy"
      />

      <section className="mx-auto max-w-4xl px-4 pb-20 pt-16 sm:px-6 lg:px-8 lg:pt-24">
        <Eyebrow>Privacy</Eyebrow>

        <h1 className="mt-5 font-display text-4xl font-extrabold tracking-tight sm:text-6xl">
          Privacy Policy
        </h1>

        <p className="mt-5 text-sm text-muted-foreground">
          Last updated October 15, 2026
        </p>

        <div className="mt-12 space-y-10 text-base leading-relaxed text-muted-foreground">
          <section>
            <h2 className="font-display text-2xl font-bold text-foreground">
              About this policy
            </h2>
            <p className="mt-4">
              This policy explains how Incolour Films Inc. collects, uses, and
              handles personal information when you use incolourfilms.ca,
              contact us about a project, or interact with our website.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-foreground">
              Information we collect
            </h2>
            <p className="mt-4">
              When you contact us through the website, we may collect the
              information you choose to provide, including your name, email
              address, company, project type, budget range, and message.
            </p>
            <p className="mt-4">
              If you choose to accept analytics, we also use Google Analytics
              to understand how visitors use the site. Analytics information
              may include pages viewed, approximate location, device and
              browser information, traffic source, and interactions with the
              website. We do not load Google Analytics until you accept
              analytics on this site.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-foreground">
              How we use information
            </h2>
            <p className="mt-4">
              We use information submitted through the site to respond to
              inquiries, evaluate potential projects and collaborations,
              provide production services, maintain business records, improve
              the website, and understand how visitors find and use Incolour.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-foreground">
              Analytics and cookies
            </h2>
            <p className="mt-4">
              Analytics are optional. If you accept analytics, Google Analytics
              may use cookies or similar technologies to measure website usage.
              Your analytics choice is stored in your browser so the site can
              remember your preference. If you decline, the website remains
              fully usable and Google Analytics is not loaded by our site.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-foreground">
              Service providers
            </h2>
            <p className="mt-4">
              We use third-party providers for services such as website
              hosting, databases, email delivery, and analytics. These
              providers may process information on our behalf and may process
              or store information outside Canada, subject to the laws of the
              jurisdictions where they operate.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-foreground">
              Retention and safeguards
            </h2>
            <p className="mt-4">
              We keep personal information only for as long as reasonably
              necessary for the purposes described above, including business,
              legal, accounting, and production-related requirements. We use
              reasonable administrative and technical measures intended to
              protect information in our care.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-foreground">
              Your choices and privacy requests
            </h2>
            <p className="mt-4">
              You can decline analytics when prompted. You may also contact us
              to ask about personal information we hold about you, request a
              correction, or raise a privacy concern, subject to applicable
              legal requirements.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-bold text-foreground">
              Contact
            </h2>
            <p className="mt-4">
              Privacy questions can be sent to{" "}
              <a
                href="mailto:connect@incolourfilms.ca"
                className="font-semibold text-foreground underline decoration-orange underline-offset-4"
              >
                connect@incolourfilms.ca
              </a>
              .
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}
